export default "__VITE_ASSET__3bK5RSBd__"